function ConnectionCtrl($auth, ConnectionService, AppSettings, toaster, $filter, $rootScope, CommonService, UserService, $stateParams, $state) {
  'ngInject';

  $rootScope.$on("UpdateConnectionFromNotification", function (event) {
    vm.updateConnectionFromNotification();
  });

  const vm = this;
  let headers = $auth.retrieveData('auth_headers');
  vm.connectionAmazon = [];
  vm.amazonForm = {};
  vm.authToken = '';
  vm.accessKey = '';
  vm.secretKey = '';
  vm.loading = false;
  vm.user = $auth.user;
  vm.organizationFlag = false;
  vm.connectedStatus = false;
  vm.amazonConnections = [];
  vm.shopifyForm = {};
  vm.shopifyConnections = [];
  vm.xeroConnection = [];
  vm.qboConnections = [];
  vm.refreshload = false;
  vm.qboRefreshLoad = false;
  vm.fullRefreshLoad = false;
  vm.xeroSortFlag = false;
  vm.xeroSortFlagUp = true;
  vm.xeroSortFlagDown = false;
  vm.sortFlag1 = false;
  vm.sortFlag2 = false;
  vm.sortFlag3 = false;
  vm.isSearch = false;
  vm.isAmazonSearch = false;
  vm.isShopifySearch = false;
  vm.isQboSearch = false;
  vm.isReportsSearch = false;
  vm.showArchivedXero = false;
  vm.showArchivedQbo = false;
  vm.editId = !$stateParams.editId ? '' : $stateParams.editId;
  vm.fullRefreshLoad = false;

  vm.setSerachAndPagination = function () {
    vm.rowPerPageOptions = ["10", "20", "30", "40", "50"];
    vm.searchPagination = {
      xero: {
        pageNumber: 1,
        size: 10,
        organization: "",
        sort: ""
      },
      qbo: {
        pageNumber: 1,
        size: 10,
        organization: "",
        sort: ""
      },
      amazon: {
        pageNumber: 1,
        size: 10,
        organization: "",
        marketPlaceId: "",
        merchantId: "",
        sort: ""
      },
      shopify: {
        pageNumber: 1,
        size: 10,
        organization: "",
        shop: "",
        sort: ""
      }
    };
  };

  vm.setSerachAndPagination();

  vm.init = function () {
    $rootScope.organizationNameView = false;
    vm.refreshAmazonConnections();
    vm.refreshShopifyConnections();
    if (vm.editId) {
      ConnectionService.editAmazonCon(vm.editId, function (response) {
        if (response.status == 200) {
          vm.setAmazonForm(response.data);
        }
      });
    } else {
      vm.amazonForm.marketplaceId = 'ATVPDKIKX0DER';
    }
  };

  vm.setAmazonForm = function (conData) {
    vm.amazonForm.id = conData.id;
    vm.amazonForm.org = conData.api_v1_organization;
    vm.amazonForm.marketplaceId = conData.mws_marketplace_id;
    vm.amazonForm.merchantId = conData.mws_merchant_id;
    vm.amazonForm.authToken = conData.auth_token;
  };

  vm.openForm = function (e) {
    vm.amazonFormAction = (vm.amazonFormAction == "add") ? "" : "add";
    if (vm.organizationFlag) {
      if (vm.user.role == 'admin') {
        $state.go('user.connection.amazon-conn');
      } else {
        $state.go('client.connectionView.amazon-conn');
      }
    } else {
      toaster.pop('info', "Connect to xero for organizations");
    }
  };

  vm.editForm = function (con) {
    vm.amazonFormAction = (vm.amazonFormAction == "edit") ? "" : "edit";
    if (vm.organizationFlag) {
      if (vm.user.role == 'admin') {
        $state.go('user.connection.amazon-conn', { editId: con.id, inherit: true });
      } else {
        $state.go('client.connectionView.amazon-conn', { editId: con.id, inherit: true });
      }
    } else {
      toaster.pop('info', "Connect to xero for organizations");
    }
  };

  vm.returnToDefault = function () {
    if (vm.user.role == 'admin') {
      $state.go('user.connection.default', { inherit: false });
    } else {
      $state.go('client.connectionView.connection', { inherit: false });
    }
  };

  vm.openShopifyForm = function () {
    vm.shopifyFormAction = (vm.shopifyFormAction == "add") ? "" : "add";
    if (vm.organizationFlag) {
      let displayCollapse = true;
      if ($('#shopify-form').hasClass('in') && !parseInt($('#shopify-form form').attr('data-id')))
        displayCollapse = false;

      if (displayCollapse) {
        $('#shopify-form').collapse('show');
        $('html,body').animate({
          scrollTop: $("#shopify-form > form").offset().top
        }, 500);
      } else {
        $('#shopify-form').collapse('hide');
      }
      vm.shopifyForm = {};
    } else {
      toaster.pop('info', "Connect to xero for organizations");
    }
  }

  vm.editShopifyForm = function (con) {
    let triggershopifyForm = !(vm.shopifyFormAction == "add");
    vm.shopifyFormAction = (vm.shopifyFormAction == "edit") ? "" : "edit";
    if (vm.organizationFlag) {
      if (parseInt($('#shopify-form > form').attr('data-id')) == con.id) {
        $('#shopify-form').collapse('hide');
        $('#shopify-form > form').attr('data-id', '');
      } else {
        $('#shopify-form').collapse('show');
        $('#shopify-form > form').attr('data-id', con.id);
        $('html,body').animate({
          scrollTop: $("#shopify-form > form").offset().top
        }, 500);
      }
    } else {
      toaster.pop('info', "Connect to xero for organizations");
    }
    vm.shopifyForm.id = con.id;
    vm.shopifyForm.org = con.api_v1_organization;
    vm.shopifyForm.loginHash = con.login_hash;
    vm.shopifyForm.passwordHash = '';
    vm.shopifyForm.domain = con.domain;
  }

  vm.clear = function () {
    if (vm.checked) {
      vm.amazonForm.authToken = '';
    } else {
      vm.amazonForm.accessKey = '';
      vm.amazonForm.secretKey = '';
    }
  }

  vm.toggleShopifyForm = function () {
    if (!$('#toggle-shopify-form').hasClass('collapse in')) {
      vm.shopifyFormAction = "";
      $('#toggle-shopify-form').trigger('click');
    }
  }

  vm.postToAmazon = function (amazonForm) {
    if (vm.amazonForm.id) {
      ConnectionService.updateAmazonCon(vm.amazonForm, vm.amazonForm.id, function (response) {
        if (response.status == 422) {
          toaster.pop('error', CommonService.throwError(response));
        } else if (response.status == 200) {
          let indexOfcon = vm.amazonConnections.amazon_connections.findIndex(i => i.id === response.data.id);
          vm.amazonConnections.amazon_connections[indexOfcon] = response.data;
          vm.amazonForm = {};
          amazonForm.$setPristine();
          amazonForm.$setUntouched();
          vm.showConnectAmazon = true;
          toaster.pop('info', 'Amazon data updated successfully');
          vm.editFlag = false;
          vm.returnToDefault();
        }
      });
    } else {
      ConnectionService.postToAmazon(vm.amazonForm, function (response) {
        if (response.status == 422) {
          toaster.pop('error', CommonService.throwError(response));
        } else if (response.status == 200) {
          vm.redirectToSPAPI(response.data.create_token);
          vm.amazonForm = {};
          amazonForm.$setPristine();
          amazonForm.$setUntouched();
          vm.showConnectAmazon = true;
          toaster.pop('info', 'Amazon data posted successfully');
          vm.returnToDefault();
        }
      });
    }
  };

  vm.deleteAmazon = function (conId) {
    swal({
      title: "Are you sure you want to delete this connection?",
      text: "All the information related with this connection will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
    })
      .then(willDelete => {
        if (willDelete) {
          ConnectionService.deleteAmazon(conId, function (response) {
            if (response.status == 204) {
              vm.removeAmazon(conId);
              toaster.pop('info', 'Amazon Connection deleted');
              $('#amazon-form').collapse('hide');
            } else {
              toaster.pop('error', ConnectionService.throwError(response));
            }
          });
        }
      });
  }

  vm.removeAmazon = function (conId) {
    for (var i = vm.amazonConnections.amazon_connections.length - 1; i >= 0; i--) {
      if (vm.amazonConnections.amazon_connections[i].id == conId) {
        vm.refreshAmazonConnections();
      }
    }
  };

  vm.connectXero = function () {
    window.location = AppSettings.apiUrl + "/xero/connect?access-token=" + headers['access-token'] + "&client=" + headers['client'] + "&expiry=" + headers['expiry'] + "&uid=" + headers['uid'];
  }

  vm.connectQbo = function () {
    window.location = AppSettings.apiUrl + "/qbo/connect?access-token=" + headers['access-token'] + "&client=" + headers['client'] + "&expiry=" + headers['expiry'] + "&uid=" + headers['uid'];
  }

  vm.sellerCentralConnect = function () {
    window.open('https://sellercentral.amazon.com/gp/mws/registration/register.html?signInPageDisplayed=1&devAuth=1&developerName=MuseMinded&devMWSAccountId=3993-4677-0525', '_blank');
  };

  vm.xeroInfo = function () {
    vm.loading = true;
    let includeArchived = vm.showArchivedXero ? '&include_archived=true' : '';
    let url = `/organizations.json?by_organization_name=${vm.searchPagination.xero.organization}&page=${vm.searchPagination.xero.pageNumber}&size=${vm.searchPagination.xero.size}&sort=${vm.searchPagination.xero.sort}${includeArchived}`;
    UserService.listOrganizations(url, function (response) {
      vm.loading = false;
      if (response && response.data && response.data.organizations) {
        vm.organization = response.data;
        vm.organizationFlag = true;
        vm.organization.organizations.forEach(function (org) {
          if (org.organization.archived_at) {
            org.organization.status = 'archived';
            org.organization.sync_status = null;
            return;
          }
          ConnectionService.getXeroStatus(org.organization.api_v1_xero_connection.id, function (resp) {
            let response = resp.data;
            org.organization.status = response.status;
            org.organization.sync_status = response.sync_status;
          });
        });
      }
    });
  };

  vm.qboInfo = function () {
    let includeArchived = vm.showArchivedQbo ? '&include_archived=true' : '';
    let url = `/qbo.json?by_organization_name=${vm.searchPagination.qbo.organization}&page=${vm.searchPagination.qbo.pageNumber}&size=${vm.searchPagination.qbo.size}${includeArchived}`;
    ConnectionService.getQboConnections(url, function (response) {
      if (response && response.status == 200) {
        vm.qboConnections = response.data;
      }
    });
  };

  // XERO Connections search and pagination event handlers
  vm.xeroSearch = function () {
    vm.xeroInfo();
    vm.isSearch = true;
  };

  vm.toggleArchivedXero = function () {
    vm.searchPagination.xero.pageNumber = 1;
    vm.xeroInfo();
  };

  vm.qboSearch = function () {
    vm.qboInfo();
    vm.isQboSearch = true;
  };

  vm.toggleArchivedQbo = function () {
    vm.searchPagination.qbo.pageNumber = 1;
    vm.qboInfo();
  };

  vm.qboPaginate = function (param) {
    let url = vm.qboConnections.links[param];
    if (url) {
      vm.searchPagination.qbo.pageNumber = CommonService.getParameterByName('page', url);
      vm.qboInfo();
    }
  };

  vm.qboRowChange = function (params, pageSize) {
    vm.searchPagination.qbo.size = pageSize;
    vm.qboInfo();
  };

  vm.xeroPaginate = function (param) {
    let url = vm.organization.links[param];
    if (url) {
      vm.searchPagination.xero.pageNumber = CommonService.getParameterByName('page', url);
      vm.xeroInfo();
    }
  };

  vm.xeroRowChange = function (params, pageSize) {
    vm.searchPagination.xero.size = pageSize;
    vm.xeroInfo();
  };

  vm.sortXeroConnections = function (sortBy) {
    if (vm.searchPagination.xero.sort.includes(sortBy)) {
      vm.searchPagination.xero.sort = vm.searchPagination.xero.sort.startsWith("-") ? sortBy : `-${sortBy}`;
    } else {
      vm.searchPagination.xero.sort = `${sortBy}`;
    }
    vm.xeroInfo();
  };

  vm.sortFlag1 = function (sortBy) {

    if (vm.searchPagination.xero.sort.includes(sortBy)) {
      if (!vm.searchPagination.xero.sort.startsWith("-")) {
        return false;
      }
    }
    return true;
  };

  // AMAZON Connections serach, pagination event handlers

  vm.amazonSearch = function () {
    vm.refreshAmazonConnections();
    vm.isAmazonSearch = true;
  };

  vm.amazonPaginate = function (param) {
    let url = vm.amazonConnections.links[param];
    if (url) {
      vm.searchPagination.amazon.pageNumber = CommonService.getParameterByName('page', url);
      vm.refreshAmazonConnections();
    }
  };

  vm.amazonRowChange = function (params, pageSize) {
    vm.searchPagination.amazon.size = pageSize;
    vm.refreshAmazonConnections();
  };

  vm.sortFlag2 = function (sortBy) {
    if (vm.searchPagination.amazon.sort.includes(sortBy)) {
      if (!vm.searchPagination.amazon.sort.startsWith("-")) {
        return false;
      }
    }
    return true;
  };

  vm.sortAmazonConnections = function (sortBy) {
    if (vm.searchPagination.amazon.sort.includes(sortBy)) {
      vm.searchPagination.amazon.sort = vm.searchPagination.amazon.sort.startsWith("-") ? sortBy : `-${sortBy}`
    } else {
      vm.searchPagination.amazon.sort = `${sortBy}`;
    }
    vm.refreshAmazonConnections();
  };

  vm.refreshAmazonConnections = function () {
    let amazonUrl = `/amazon_connections.json?by_organization=${vm.searchPagination.amazon.organization}&page=${vm.searchPagination.amazon.pageNumber}&size=${vm.searchPagination.amazon.size}&by_merchant=${vm.searchPagination.amazon.merchantId}&by_marketplace=${vm.searchPagination.amazon.marketPlaceId}&sort=${vm.searchPagination.amazon.sort}`;
    ConnectionService.connectAmazon(amazonUrl, function (response) {
      if (response.status == 200) {
        vm.amazonConnections = response.data;
        vm.connectedStatus = true;
      }
    });
  };

  // Shopofy search and pagination event handlers
  vm.shopifySearch = function () {
    vm.refreshShopifyConnections();
    vm.isShopifySearch = true;
  };

  vm.shopifyPaginate = function (param) {
    let url = vm.shopifyConnections.links[param];
    if (url) {
      vm.searchPagination.shopify.pageNumber = CommonService.getParameterByName('page', url);
      vm.refreshShopifyConnections();
    }
  };
  vm.connectToShopify = function () {
    window.location = AppSettings.apiUrl + "/shopify_oauth_connections/connect?access-token=" + headers['access-token'] + "&client=" + headers['client'] + "&expiry=" + headers['expiry'] + "&uid=" + headers['uid'] + "&shop_name=" + vm.shopifyForm.shop + "&organization_id=" + vm.shopifyForm.org.id;
  }

  vm.shopifyRowChange = function (params, pageSize) {
    vm.searchPagination.shopify.size = pageSize;
    vm.refreshShopifyConnections();
  };

  vm.sortFlag3 = function (sortBy) {
    if (vm.searchPagination.shopify.sort.includes(sortBy)) {
      if (!vm.searchPagination.shopify.sort.startsWith("-")) {
        return false;
      }
    }
    return true;
  };

  vm.sortShopifyConnections = function (sortBy) {
    if (vm.searchPagination.shopify.sort.includes(sortBy)) {
      vm.searchPagination.shopify.sort = vm.searchPagination.shopify.sort.startsWith("-") ? sortBy : `-${sortBy}`
    } else {
      vm.searchPagination.shopify.sort = `${sortBy}`;
    }
    vm.refreshShopifyConnections();
  };

  vm.refreshShopifyConnections = function () {
    let shopifyUrl = `/shopify_oauth_connections.json?by_organization=${vm.searchPagination.shopify.organization}&page=${vm.searchPagination.shopify.pageNumber}&size=${vm.searchPagination.shopify.size}&by_shop=${vm.searchPagination.shopify.shop}&sort=${vm.searchPagination.shopify.sort}`;
    ConnectionService.getShopifyOauthConnections(shopifyUrl, function (response) {
      if (response.status == 200) {
        vm.shopifyConnections = response.data;
        vm.connectedStatus = true;
      }
    });
  };

  // Reports search event handler
  vm.reportsSearch = function () {
    vm.refreshShopifyConnections();
    vm.isReportsSearch = true;
  };

  vm.refreshCache = function (organization_id) {
    vm.refreshload = true;
    ConnectionService.refreshCache(organization_id, function (response) {
      vm.refreshload = false;
      if(response.status == 200){
        toaster.pop('info', response.data.message);
      }
      vm.xeroInfo();
    });
  }

  vm.fullRefresh = function(organization_id){
    vm.fullRefreshLoad = true;
    ConnectionService.fullRefresh(organization_id, function(response){
      vm.fullRefreshLoad = false;
      if(response.status == 200){
        toaster.pop('info', response.data.message);
      }
      vm.xeroInfo();
    });
  }

  vm.disconnectXero = function (organization_id) {
    ConnectionService.disconnect(organization_id, function (response) {
      if (response.status = '204') {
        let index = vm.organization.organizations.map(function (el) {
          return el.organization.id;
        }).indexOf(organization_id);
        vm.organization.organizations[index].organization.status = 'disconnected';
      }
    });
  }

  vm.disconnectQbo = function (organization_id) {
    ConnectionService.disconnectQbo(organization_id, function (response) {
      if (response.status == 204) {
        toaster.pop('info', 'QuickBooks connection disconnected');
        vm.qboInfo();
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  }

  vm.refreshQboCache = function (organization_id) {
    vm.qboRefreshLoad = true;
    ConnectionService.refreshQboCache(organization_id, function (response) {
      vm.qboRefreshLoad = false;
      if (response.status == 200) {
        toaster.pop('info', response.data.message);
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
      vm.qboInfo();
    });
  }

  vm.archiveXero = function (organization_id) {
    swal({
      title: "Archive this Xero client?",
      text: "This will hide the client from normal Gemini views without deleting historical data or disconnecting Xero.",
      icon: "warning",
      dangerMode: false,
      buttons: [true, true]
    })
      .then(willArchive => {
        if (willArchive) {
          ConnectionService.archiveXero(organization_id, function (response) {
            if (response.status == 200) {
              toaster.pop('info', 'Xero client archived');
              vm.xeroInfo();
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }
      });
  }

  vm.unarchiveXero = function (organization_id) {
    ConnectionService.unarchiveXero(organization_id, function (response) {
      if (response.status == 200) {
        toaster.pop('info', 'Xero client restored');
        vm.xeroInfo();
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  }

  vm.archiveQbo = function (organization_id) {
    swal({
      title: "Archive this QuickBooks client?",
      text: "This will hide the client from normal Gemini views without deleting historical data or disconnecting QuickBooks.",
      icon: "warning",
      dangerMode: false,
      buttons: [true, true]
    })
      .then(willArchive => {
        if (willArchive) {
          ConnectionService.archiveQbo(organization_id, function (response) {
            if (response.status == 200) {
              toaster.pop('info', 'QuickBooks client archived');
              vm.qboInfo();
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }
      });
  }

  vm.unarchiveQbo = function (organization_id) {
    ConnectionService.unarchiveQbo(organization_id, function (response) {
      if (response.status == 200) {
        toaster.pop('info', 'QuickBooks client restored');
        vm.qboInfo();
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  }

  vm.scheduleXeroPurge = function (organization) {
    if (!organization.archived_at) {
      toaster.pop('error', 'Archive the client before scheduling purge');
      return;
    }

    let days = parseInt(window.prompt('Days until full deletion?', '7'), 10);
    if (!days || days < 1) {
      toaster.pop('error', 'Deletion schedule cancelled');
      return;
    }

    swal({
      title: "Schedule full deletion?",
      text: `This schedules this archived client for full deletion in ${days} day(s). You can cancel before then. When the schedule is due, Gemini will delete the organization data and disconnect Xero.`,
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
    })
      .then(willSchedule => {
        if (willSchedule) {
          ConnectionService.scheduleXeroPurge(organization.id, days, function (response) {
            if (response.status == 200) {
              toaster.pop('info', 'Client scheduled for full deletion');
              vm.xeroInfo();
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }
      });
  }

  vm.cancelXeroPurge = function (organization_id) {
    swal({
      title: "Cancel scheduled deletion?",
      text: "This keeps the client archived and prevents the purge job from deleting it.",
      icon: "warning",
      dangerMode: false,
      buttons: [true, true]
    })
      .then(willCancel => {
        if (willCancel) {
          ConnectionService.cancelXeroPurge(organization_id, function (response) {
            if (response.status == 200) {
              toaster.pop('info', 'Scheduled deletion cancelled');
              vm.xeroInfo();
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }
      });
  }

  vm.deleteXero = function (organization_id) {
    swal({
      title: "Are you sure you want to delete this connection?",
      text: "All the information related with this connection will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
    })
      .then(willDelete => {
        if (willDelete) {
          ConnectionService.delete(organization_id, function (response) {
            if (response.status == 204) {
              vm.xeroInfo();
            }
          });
        }
      });
  }

  vm.postToShopify = function (shopifyForm) {
    if (vm.shopifyForm.id) {
      ConnectionService.updateShopifyCon(vm.shopifyForm, vm.shopifyForm.id, function (response) {
        if (response.status == 422) {
          toaster.pop('error', CommonService.throwError(response));
        } else if (response.status == 200) {
          let indexOfcon = vm.shopifyConnections.shopify_connections.findIndex(i => i.id === response.data.id);
          vm.shopifyConnections.shopify_connections[indexOfcon] = response.data;
          vm.shopifyForm = {};
          shopifyForm.$setPristine();
          shopifyForm.$setUntouched();
          vm.showConnectShopify = true;
          vm.toggleShopifyForm();
          toaster.pop('info', 'Shopify data updated successfully');
          vm.editFlag = false;
        }
      });
    } else {
      ConnectionService.postToShopify(vm.shopifyForm, function (response) {
        if (response.status == 422) {
          toaster.pop('error', CommonService.throwError(response));
        } else if (response.status == 201) {
          vm.shopifyForm = {};
          shopifyForm.$setPristine();
          shopifyForm.$setUntouched();
          vm.showConnectShopify = true;
          vm.toggleShopifyForm();
          toaster.pop('info', 'Shopify data posted successfully');
          vm.refreshShopifyConnections();
        }
      });
    }
  };

  vm.deleteOauthShopify = function (conId) {
    swal({
      title: "Are you sure you want to delete this connection?",
      text: "All the information related with this connection will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
    })
      .then(willDelete => {
        if (willDelete) {
          ConnectionService.deleteOauthShopify(conId, function (response) {
            vm.removeShopify(conId);
            if (response.status == 204) {
              $('#shopify-form').collapse('hide');
              toaster.pop('info', 'Shopify Connection deleted');
            } else {
              toaster.pop('error', ConnectionService.throwError(response));
            }
          });
        }
      });
  }

  vm.removeShopify = function (conId) {
    for (var i = vm.shopifyConnections.shopify_connections.length - 1; i >= 0; i--) {
      if (vm.shopifyConnections.shopify_connections[i].id == conId) {
        vm.refreshShopifyConnections();
      }
    }
  };

  vm.updateConnectionFromNotification = function () {
    vm.xeroInfo();
    vm.qboInfo();
  };

  vm.getOrgStatus = function (status) {
    if (status == 'active') {
      return "label label-success";
    } else if (status == 'expired') {
      return "label label-danger";
    } else if (status == 'archived') {
      return "label label-warning";
    } else {
      return "label label-default";
    }
  };

  vm.redirectToSPAPI = function(connectionId){
    let versionValue = process.env.NODE_ENV !== 'production' ? '&version=beta' : '';
    let amazonUrl = 'https://sellercentral.amazon.com/apps/authorize/consent?application_id='+AppSettings.amazonApplicationId +'&redirect_uri='+AppSettings.redirectUri+'&state='+connectionId.toString() + versionValue;
    window.open(amazonUrl)
  };
};

export default {
  name: 'ConnectionCtrl',
  fn: ConnectionCtrl
}
